'use client';

type Props = {
  className?: string;
  messageKey?: string;
};

/**
 * Localized Suspense fallback. Renders just a spinner — language-neutral,
 * so it works correctly during SSR and before lazy-loaded locale files
 * (e.g. ru.json) are available.
 */
export default function LoadingFallback({ className = '' }: Props) {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className="w-6 h-6 border-2 border-wood/20 border-t-wood rounded-full animate-spin" />
    </div>
  );
}
